<!-- eslint-disable max-len -->
<template>
  <div
    id="container-external-api"
    class="container-form-ui">
    <h3 class="modal-title"> {{ fieldDetail ? 'EDIT FIELD': 'ADD FIELD' }} </h3>
    <b-row>
      <b-col
        :md="isHaveConfig ? '6' : '12'">
        <h4>Properties</h4>
        <b-form :class="{'error-input' : $v.dataSetup.type.$error}">
          <div class="title-field">
            <label> Type </label>
            <jTooltipCreateView description="Type Information" />
          </div>
          <j-single-select
            v-model="dataSetup.type"
            :options="typeFieldByType"
            :placeholder="'Select Type'"
            value-format="object"
            label="text"/>
        </b-form>
        <b-row v-if="!isSearch">
          <b-col :md="isHaveConfig || isDataset ? '12' : '6'">
            <b-form :class="{'error-input' : $v.dataSetup.key.$error}">
              <div class="title-field">
                <label> Key </label>
                <jTooltipCreateView description="Key Information" />
              </div>
              <j-input
                v-model="dataSetup.key"
                placeholder="Enter key"/>
            </b-form>
          </b-col>
          <b-col
            v-if="!isDataset"
            :md="isHaveConfig ? '4' : '2'">
            <b-form :class="{'error-input' : $v.dataSetup.isDisable.$error}">
              <label> Disable </label>
              <j-toggle v-model="dataSetup.isDisable" />
            </b-form>
          </b-col>
          <b-col
            v-if="!isDataset"
            :md="isHaveConfig ? '4' : '2'">
            <b-form :class="{'error-input' : $v.dataSetup.isMandatory.$error}">
              <label> Mandatory </label>
              <j-toggle v-model="dataSetup.isMandatory" />
            </b-form>
          </b-col>
          <b-col
            v-if="!isDataset"
            :md="isHaveConfig ? '4' : '2'">
            <b-form :class="{'error-input' : $v.dataSetup.isHidden.$error}">
              <label> Hidden </label>
              <j-toggle v-model="dataSetup.isHidden" />
            </b-form>
          </b-col>
        </b-row>
        <b-form :class="{'error-input' : $v.dataSetup.name.$error}">
          <div class="title-field">
            <label> Name </label>
            <jTooltipCreateView description="Name Information" />
          </div>
          <j-input
            v-model="dataSetup.name"
            placeholder="Enter field name"/>
        </b-form>
        <b-form
          v-if="!isSearch"
          :class="{'error-input' : $v.dataSetup.placeholder.$error}">
          <div class="title-field">
            <label> Placeholder </label>
            <jTooltipCreateView description="Placeholder Information" />
          </div>
          <j-input
            v-model="dataSetup.placeholder"
            placeholder="Enter field placeholder"/>
        </b-form>
        <b-form
          v-if="!isSearch"
          :class="{'error-input' : $v.dataSetup.grid.$error}">
          <div class="title-field">
            <label> Grid </label>
            <jTooltipCreateView description="Grid Information" />
          </div>
          <j-single-select
            v-model="dataSetup.grid"
            :options="listGrid"
            :placeholder="'Select Grid'"
            :disabled="isNoGrid"
            label="text"/>
        </b-form>
        <b-form
          v-if="!isSearch && !isDataset &&
            (dataSetup.type.id === 'text' ||
            dataSetup.type.id === 'descriptive' ||
            dataSetup.type.id === 'number'||
            dataSetup.type.id === 'number_decimal' ||
            dataSetup.type.id === 'date' ||
            dataSetup.type.id === 'time' ||
            dataSetup.type.id === 'date_time' ||
            dataSetup.type.id === 'currency' ||
          dataSetup.type.id === 'single_selection')"
          :class="{'error-input' : $v.dataSetup.defaultValue.$error}">
          <div class="title-field">
            <label> Default Value </label>
            <jTooltipCreateView description="Default Value Information" />
          </div>
          <j-input
            v-if="dataSetup.type.id === 'text' || dataSetup.type.id === 'descriptive' || dataSetup.type.id === 'single_selection'"
            v-model="dataSetup.defaultValue"
            placeholder="Enter Default Value"/>
          <j-input
            v-if="dataSetup.type.id === 'number' || dataSetup.type.id === 'number_decimal'"
            v-model="dataSetup.defaultValue"
            placeholder="Enter Default Value"
            type="number"/>
          <j-date-time
            v-if="dataSetup.type.id === 'date'"
            :type="'date'"
            :data="dataSetup.defaultValue"
            placeholder="Enter Default Value"
            class="m__b--25"
            @getTimestamp="setValueDateAndAtime($event, dataSetup.defaultValue)"/>
          <j-clockpicker
            v-if="dataSetup.type.id === 'time'"
            :data="dataSetup.defaultValue"
            placeholder="Enter Default Value"
            @input="setValueDateAndAtime($event, dataSetup.defaultValue)"/>
          <j-date-time
            v-if="dataSetup.type.id === 'date_time'"
            :type="'datetime'"
            :data="dataSetup.defaultValue"
            placeholder="Enter Default Value"
            class="m__b--25"
            @getTimestamp="setValueDateAndAtime($event, dataSetup.defaultValue)"/>
          <j-currency
            v-if="dataSetup.type.id === 'currency'"
            v-model="dataSetup.defaultValue"
            :options="exampleOptionCurrency"
            :input_mode="true"
            placeholder="Enter Default Value"/>
        </b-form>
        <div v-show="dataSetup.type && (dataSetup.type.id !== 'separator' && dataSetup.type.id !== 'custom_html')">
          <h4>Parse Value To</h4>
          <b-form :class="{'error-input' : $v.dataSetup.variable.$error}">
            <div class="title-field">
              <label> Variable </label>
              <jTooltipCreateView description="Variable Information" />
            </div>
            <j-single-select
              v-model="dataSetup.variable"
              :options="variableOptionsFiltered"
              :placeholder="'Select Variable'"
              value-format="object"
              label="label"/>
          </b-form>
        </div>
      </b-col>
      <b-col
        v-if="isHaveConfig"
        md="6">
        <h4>Config</h4>
        <div v-if="dataSetup.type.id === 'location'">
          <b-form :class="{'error-input' : $v.dataSetup.locationType.$error}">
            <label> Location Type </label>
            <j-single-select
              v-model="dataSetup.locationType"
              :options="listLocationType"
              :placeholder="'Select Location Type'"
              label="text"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.isShowMaps.$error}">
            <label> Show Maps </label>
            <j-toggle v-model="dataSetup.isShowMaps" />
          </b-form>
        </div>
        <div
          v-if="dataSetup.type.id === 'single_selection'||
            dataSetup.type.id === 'multiple_selection'||
            dataSetup.type.id === 'photo' ||
            dataSetup.type.id === 'attachment'
          ">
          <h4>Options</h4>
          <div
            v-for="(itemOptions, index) in dataSetup.options"
            :key="index">
            <b-row>
              <b-col md="10">
                <b-form :class="{'error-input' : $v.dataSetup.options.$each[index].$error}">
                  <j-input
                    v-model="dataSetup.options[index]"
                    placeholder="Enter options"/>
                </b-form>
              </b-col>
              <b-col
                md="2"
                class="p__l--1 m__t--5">
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteOptions(index)"/>
              </b-col>
            </b-row>
          </div>
          <div
            class="btn-add-column m__b--15"
            @click="addoptions">
            + Add options
          </div>
        </div>
        <div v-if="dataSetup.type.id === 'radio' || dataSetup.type.id === 'checkbox'">
          <h4>Options</h4>
          <div
            v-for="(itemOptions, index) in dataSetup.optionsObject"
            :key="index">
            <b-row>
              <b-col md="10">
                <b-form>
                  <label> Label </label>
                  <j-input
                    v-model="dataSetup.optionsObject[index].label"
                    placeholder="Enter label"/>
                </b-form>
              </b-col>
              <b-col
                md="2"
                class="p__l--1 m__t--5">
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteOptionsObject(index)"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="10">
                <b-form>
                  <label> Value </label>
                  <j-input
                    v-model="dataSetup.optionsObject[index].value"
                    placeholder="Enter value"/>
                </b-form>
              </b-col>
            </b-row>
          </div>
          <div
            class="btn-add-column m__b--15"
            @click="addoptionsObject">
            + Add options
          </div>
        </div>
        <div v-if="dataSetup.type.id === 'attachment' || dataSetup.type.id === 'multiple_attachment_dynamic' || dataSetup.type.id === 'single_attachment'">
          <b-form :class="{'error-input' : $v.dataSetup.acceptedFileType.$error}">
            <label> Accepted File Type </label>
            <j-multi-select
              v-model="$v.dataSetup.acceptedFileType.$model"
              :options="list_accepted_file_type"
              placeholder="Select Accepted File Type"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.isUseCamera.$error}">
            <label> Use Camera </label>
            <j-toggle v-model="dataSetup.isUseCamera" />
          </b-form>
          <div v-if="dataSetup.isUseCamera">
            <b-form :class="{'error-input' : $v.dataSetup.sourceCamera.$error}">
              <label> Source </label>
              <b-form-radio-group
                v-model="$v.dataSetup.sourceCamera.$model"
                :options="list_source_camera"
                :stacked="true"
                class="jFormGroup"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.chooseCamera.$error}">
              <label> Choose Camera </label>
              <j-single-select
                v-model="$v.dataSetup.chooseCamera.$model"
                :options="list_choose_camera"
                placeholder="Choose Camera"/>
            </b-form>
          </div>
          <b-form :class="{'error-input' : $v.dataSetup.isUseWatermark.$error}">
            <label> Use Watermark </label>
            <j-toggle v-model="dataSetup.isUseWatermark" />
          </b-form>
          <b-form
            v-if="dataSetup.isUseWatermark"
            :class="{'error-input' : $v.dataSetup.field1.$error}">
            <label> Field 1 </label>
            <j-single-select
              v-model="dataSetup.field1"
              :options="variableOptionsWatermark"
              :placeholder="'Select Field'"
              label="label"/>
          </b-form>
          <b-form
            v-if="dataSetup.isUseWatermark"
            :class="{'error-input' : $v.dataSetup.field2.$error}">
            <label> Field 2 </label>
            <j-single-select
              v-model="dataSetup.field2"
              :options="variableOptionsWatermark"
              :placeholder="'Select Field'"
              label="label"/>
          </b-form>
          <b-form
            v-if="dataSetup.isUseWatermark"
            :class="{'error-input' : $v.dataSetup.field3.$error}">
            <label> Field 3 </label>
            <j-single-select
              v-model="dataSetup.field3"
              :options="variableOptionsWatermark"
              :placeholder="'Select Field'"
              label="label"/>
          </b-form>
        </div>
        <div v-if="dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'multiple_relation_record'">
          <div class="container-relation-record">
            <h4>Source Data</h4>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.tableGroup.$error}">
              <label> Table Group </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.tableGroup.$model"
                :error-required="$v.dataSetup.sourceData.tableGroup.$error"
                :options="tableGroupOptions"
                :placeholder="'Select Table Group'"
                value-format="object"
                label="name"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.form.$error}">
              <label> Table </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.form.$model"
                :error-required="$v.dataSetup.sourceData.form.$error"
                :disabled="!dataSetup.sourceData.tableGroup"
                :options="tableOptions"
                :placeholder="'Select Table'"
                value-format="object"
                label="name"/>
            </b-form>
          </div>

          <div class="container-relation-record">
            <h4>Filter</h4>
            <div class="d-flex m__b--20">
              <div
                :class="{'tab-filter-active' : tabSelected === 'value'}"
                class="tab-filter m__r--15 p__l--10 p__r--10"
                @click="tabSelected = 'value'">
                VALUE
              </div>
              <div
                v-if="!isBulk"
                :class="{'tab-filter-active' : tabSelected === 'column'}"
                class="tab-filter p__l--10 p__r--10"
                @click="tabSelected = 'column'">
                COLUMN
              </div>
            </div>

            <div v-if="tabSelected === 'value'">
              <b-row
                v-for="(data, index) in dataSetup.filter"
                :key="index"
                class="filter-container w--100">
                <b-col cols="11">
                  <b-form class="mb-2">
                    <label> Key </label>
                    <j-single-select
                      v-model="data.key"
                      :error-required="false"
                      :options="list_field_class"
                      :placeholder="'Filter by'"
                      value-format="object"
                      label="label"/>
                  </b-form>
                  <b-form class="mb-3">
                    <label> Value </label>
                    <j-input
                      v-model="data.value"
                      :error-required="false"
                      :placeholder="'Enter value'"/>
                  </b-form>
                </b-col>
                <b-col
                  cols="1"
                  class="d-flex align-items-start justify-content-center mt-2 pl-0 cursor-pointer">
                  <i
                    class="fa fa-trash"
                    @click="deleteFilter(index)"
                  />
                </b-col>
              </b-row>
              <div
                class="btn-add-column"
                @click="addFilter">
                + Add parameter
              </div>

              <b-form>
                <label> Filter Operator </label>
                <j-single-select
                  v-model="dataSetup.filterOperator"
                  :error-required="false"
                  :options="filterOperatorOptions"
                  :placeholder="'Filter Operator'"
                  label="name"/>
              </b-form>
            </div>

            <div v-if="tabSelected === 'column'">
              <b-form :class="{'error-input' : $v.dataSetup.isWithParam.$error}">
                <label> With Parameter </label>
                <j-toggle v-model="dataSetup.isWithParam" />
              </b-form>
              <b-row>
                <b-col cols="12">
                  <b-form
                    :class="{'error-input' : $v.dataSetup.filterColumn.$error}"
                    class="mb-2"
                  >
                    <label> Column </label>
                    <j-single-select
                      v-model="$v.dataSetup.filterColumn.$model"
                      :error-required="$v.dataSetup.filterColumn.$model"
                      :options="list_field_class"
                      label="label"
                      placeholder="Select Column"/>
                  </b-form>
                  <b-form
                    :class="{'error-input' : $v.dataSetup.fieldKey.$error}"
                    class="mb-2"
                  >
                    <label> Field </label>
                    <j-single-select
                      v-model="$v.dataSetup.fieldKey.$model"
                      :error-required="$v.dataSetup.fieldKey.$model"
                      :options="list_field_key"
                      label="name"
                      placeholder="Select Field"/>
                  </b-form>
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="container-relation-record">
            <h4>Sorting</h4>
            <b-row>
              <b-col cols="12">
                <b-form
                  :class="{'error-input' : $v.dataSetup.sorting.key.$error}"
                  class="mb-2"
                >
                  <label> Sort By </label>
                  <j-single-select
                    v-model="dataSetup.sorting.key"
                    :error-required="false"
                    :options="list_field_class"
                    :placeholder="'Sort by'"
                    value-format="object"
                    label="label"/>
                </b-form>
              </b-col>
              <b-col cols="12">
                <b-form
                  :class="{'error-input' : $v.dataSetup.sorting.order.$error}"
                  class="mb-3"
                >
                  <label> Order By </label>
                  <j-single-select
                    v-model="dataSetup.sorting.order"
                    :error-required="false"
                    :options="orderOptions"
                    :placeholder="'Order by'"
                    value-format="object"
                    label="label"/>
                </b-form>
              </b-col>
            </b-row>
          </div>

          <div
            v-if="dataSetup.type.id === 'relation_record' && !isBulk && !isSearch"
            class="container-relation-record">
            <b-row>
              <b-col md="6">
                <h4> Auto Fill </h4>
              </b-col>
              <b-col
                md="6"
                style="padding-left: 30%">
                <j-toggle v-model="dataSetup.isAutoFill"/>
              </b-col>
            </b-row>

            <div v-if="list_field.length > 0 && dataSetup.isAutoFill">
              <h4>List Field</h4>
              <draggable v-model="dataSetup.fieldGroup">
                <transition-group class="row">
                  <div
                    v-for="(data, index) in dataSetup.fieldGroup"
                    :key="index"
                    class="col-md-12">
                    <div class="list-column-field">
                      <div class="col-one">
                        <div class="label--name ellipsis">{{ data.name }}</div>
                        <div class="ellipsis">{{ data.type }}</div>
                      </div>
                      <div class="col-two">
                        <div class="ellipsis">UI Key : {{ data.field_ui_key }}</div>
                        <div class="ellipsis">Data Key : {{ data.field_data_key }}</div>
                      </div>
                      <div class="col-three">
                        <i
                          class="fa fa-lg fa-trash pull-right cursor-pointer m__r--5 m__t--5"
                          @click="deleteField(index)"
                        />
                        <i
                          class="fa fa-lg fa-pencil pull-right cursor-pointer m__r--5 m__t--5"
                          @click="openModalEditField(data, index)"
                        />
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div
                id="fieldGroupAdd"
                class="btn-add-column"
                @click="openModalEditField(null, 0)">
                + Add field
              </div>

              <b-popover
                ref="popoverFieldGroup"
                target="fieldGroupAdd"
                container="container-external-api"
                placement="auto">
                <j-column-edit-fill
                  v-if="isOpen"
                  :field-detail="selectedField"
                  :variable-options="list_field"
                  :type="dataSetup.type.id"
                  :is-external="false"
                  @close-modal="closeModalEditField"
                  @submit-mode="submitField"
                /><br><br>
              </b-popover>
            </div>
          </div>

          <div class="container-relation-record">
            <h4>Configuration</h4>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.setValue.$error}">
              <label> Set Value Selected </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.setValue.$model"
                :options="list_field"
                label="name"
                placeholder="Select Variable"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.showData.$error}">
              <label> Show Data Option </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.showData.$model"
                :options="list_field"
                label="name"
                placeholder="Select Variable"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.searchData.$error}">
              <label> Search Data Option </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.searchData.$model"
                :options="list_field"
                label="name"
                placeholder="Select Variable"/>
            </b-form>
            <b-row>
              <b-col md="6">
                <b-form :class="{'error-input' : $v.dataSetup.isAutoShow.$error}">
                  <label> Auto Show </label>
                  <j-toggle v-model="dataSetup.isAutoShow" />
                </b-form>
              </b-col>
              <b-col md="6">
                <b-form v-if="dataSetup.type.id === 'multiple_relation_record'">
                  <label> Allow Select All  Data </label>
                  <j-toggle v-model="dataSetup.isAllowSelectAllData" />
                </b-form>
              </b-col>
            </b-row>
          </div>

          <div
            v-if="dataSetup.type.id === 'relation_record' && !isBulk && !isSearch && !isDataset"
            class="container-config__item">
            <b-form :class="{'error-input' : $v.dataSetup.isValueChange.$error}">
              <b-row>
                <b-col :md="10">
                  <div class="title-field">
                    <label> On Value Change </label>
                    <jTooltipCreateView description="On Value Change Information" />
                  </div>
                </b-col>
                <b-col :md="2">
                  <j-toggle v-model="dataSetup.isValueChange" />
                </b-col>
              </b-row>
            </b-form>
            <b-form
              v-if="useEditorCode"
              :class="{'error-input' : $v.dataSetup.onValueChange.$error}"
            >
              <label> Script </label>
              <j-monaco-editor
                v-if="openEditor"
                ref="scriptEditor"
                :value="dataSetup.onValueChange"
              />
            </b-form>
          </div>
        </div>
        <div v-if="dataSetup.type.id === 'relation_record_external_api' || dataSetup.type.id === 'multiple_relation_record_external_api'">
          <div class="container-relation-record">
            <h4>Source Data</h4>
            <div class="external-ui">
              External API <br>
              <span
                id="externalApiAdd"
                class="font-blue cursor-pointer">
                Config
              </span>
            </div>
          </div>

          <div class="container-relation-record">
            <h4>Configuration</h4>
            <b-form :class="{'error-input' : $v.dataSetup.sourceExternalVariable.$error}">
              <label> Show Data Option </label>
              <j-input
                v-model="dataSetup.sourceExternalVariable"
                placeholder="Enter variable"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceExternalSetValue.$error}">
              <label> Set Value Selected </label>
              <j-single-select
                v-model="$v.dataSetup.sourceExternalSetValue.$model"
                :options="list_field_external"
                placeholder="Select Variable"/>
            </b-form>
            <b-row>
              <b-col md="6">
                <b-form :class="{'error-input' : $v.dataSetup.isAutoShow.$error}">
                  <label> Auto Show </label>
                  <j-toggle v-model="dataSetup.isAutoShow" />
                </b-form>
              </b-col>
              <b-col md="6">
                <b-form v-if="dataSetup.type.id === 'multiple_relation_record_external_api'">
                  <label> Allow Select All  Data </label>
                  <j-toggle v-model="dataSetup.isAllowSelectAllData" />
                </b-form>
              </b-col>
            </b-row>
          </div>

          <div
            v-if="dataSetup.type.id === 'relation_record_external_api' && !isBulk && !isSearch"
            class="container-relation-record">
            <b-row>
              <b-col md="6">
                <h4> Auto Fill </h4>
              </b-col>
              <b-col
                md="6"
                style="padding-left: 30%">
                <j-toggle v-model="dataSetup.isAutoFill"/>
              </b-col>
            </b-row>

            <div v-if="dataSetup.isAutoFill">
              <h4>List Field</h4>
              <draggable v-model="dataSetup.fieldGroup">
                <transition-group class="row">
                  <div
                    v-for="(data, index) in dataSetup.fieldGroup"
                    :key="index"
                    class="col-md-12">
                    <div class="list-column-field">
                      <div class="col-one">
                        <div class="label--name ellipsis">{{ data.name }}</div>
                        <div class="ellipsis">{{ data.type }}</div>
                      </div>
                      <div class="col-two">
                        <div class="ellipsis">UI Key : {{ data.field_ui_key }}</div>
                        <div class="ellipsis">Data Key : {{ data.field_data_key }}</div>
                      </div>
                      <div class="col-three">
                        <i
                          class="fa fa-lg fa-trash pull-right cursor-pointer m__r--5 m__t--5"
                          @click="deleteField(index)"
                        />
                        <i
                          class="fa fa-lg fa-pencil pull-right cursor-pointer m__r--5 m__t--5"
                          @click="openModalEditField(data, index)"
                        />
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div
                id="fieldGroupAdd"
                class="btn-add-column"
                @click="openModalEditField(null, 0)">
                + Add field
              </div>

              <b-popover
                ref="popoverFieldGroup"
                target="fieldGroupAdd"
                container="container-external-api"
                placement="auto">
                <j-column-edit-fill
                  v-if="isOpen"
                  :field-detail="selectedField"
                  :variable-options="list_field"
                  :type="dataSetup.type.id"
                  :is-external="true"
                  @close-modal="closeModalEditField"
                  @submit-mode="submitField"
                /><br><br>
              </b-popover>
            </div>
          </div>
          <div
            v-if="dataSetup.type.id === 'relation_record_external_api' && !isBulk && !isSearch"
            class="container-config__item">
            <b-form :class="{'error-input' : $v.dataSetup.isValueChange.$error}">
              <b-row>
                <b-col :md="10">
                  <div class="title-field">
                    <label> On Value Change </label>
                    <jTooltipCreateView description="On Value Change Information" />
                  </div>
                </b-col>
                <b-col :md="2">
                  <j-toggle v-model="dataSetup.isValueChange" />
                </b-col>
              </b-row>
            </b-form>
            <b-form
              v-if="useEditorCode"
              :class="{'error-input' : $v.dataSetup.onValueChange.$error}"
            >
              <label> Script </label>
              <j-monaco-editor
                v-if="openEditor"
                ref="scriptEditor"
                :value="dataSetup.onValueChange"
              />
            </b-form>
          </div>

          <b-popover
            ref="popoverExternalApi"
            :show.sync="popoverExternalApiShow"
            target="externalApiAdd"
            container="container-external-api"
            triggers="click"
            placement="left">
            <j-external-api-field
              :data-edit="dataSetup.sourceExternal"
              @submit-data="submitExternalUrl"
              @close-modal="closeModalExternalUrl"
            />
          </b-popover>
        </div>
        <div v-if="(dataSetup.type.id === 'group' || dataSetup.type.id === 'table_group') && variableOptionsGroup.length > 0">

          <div class="container-group-table-group">
            <h4>Field Group</h4>
            <draggable v-model="dataSetup.fieldGroup">
              <transition-group class="row">
                <div
                  v-for="(data, index) in dataSetup.fieldGroup"
                  :key="index"
                  class="col-md-12">
                  <div class="list-column-field">
                    <div class="col-one">
                      <div class="label--name ellipsis">{{ data.name }}</div>
                      <div class="ellipsis">{{ data.type }}</div>
                    </div>
                    <div class="col-two">
                      <div class="ellipsis">UI Key : {{ data.field_ui_key }}</div>
                      <div class="ellipsis">Data Key : {{ data.field_data_key }}</div>
                    </div>
                    <div class="col-three">
                      <i
                        class="fa fa-lg fa-trash pull-right cursor-pointer m__r--5 m__t--5"
                        @click="deleteField(index)"
                      />
                      <i
                        class="fa fa-lg fa-pencil pull-right cursor-pointer m__r--5 m__t--5"
                        @click="openModalEditField(data, index)"
                      />
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div
              id="fieldGroupAdd"
              class="btn-add-column"
              @click="openModalEditField(null, 0)">
              + Add field
            </div>
          </div>

          <div class="container-group-table-group">
            <h4>Disable Buttons</h4>
            <b-row>
              <b-col :md="4">
                <b-form :class="{'error-input' : $v.dataSetup.isDisableAddMore.$error}">
                  <label> Add More </label>
                  <j-toggle v-model="dataSetup.isDisableAddMore" />
                </b-form>
              </b-col>
              <b-col :md="4">
                <b-form :class="{'error-input' : $v.dataSetup.isDisableDeleteRow.$error}">
                  <label> Delete Row </label>
                  <j-toggle v-model="dataSetup.isDisableDeleteRow" />
                </b-form>
              </b-col>
            </b-row>
          </div>

          <b-popover
            ref="popoverFieldGroup"
            target="fieldGroupAdd"
            container="container-external-api"
            placement="auto">
            <j-column-edit-group
              v-if="isOpen"
              :field-detail="selectedField"
              :variable-options="variableOptionsGroup"
              :field-ui-key="dataSetup.fieldGroup"
              :type="dataSetup.type.id"
              :is-external="false"
              :is-detail-view="isDetailView"
              @close-modal="closeModalEditField"
              @submit-mode="submitField"
            /><br><br>
          </b-popover>
        </div>
        <div v-if="dataSetup.type.id === 'single_tags_selection' || dataSetup.type.id === 'multiple_tags_selection'">
          <h4 class="p__b--10">Options</h4>
          <div
            v-for="(item, index) in dataSetup.tags"
            :key="index"
            class="container-group__item">
            <span class="item__counter-group">
              {{ index + 1 }}
            </span>
            <span
              class="item__remove cursor-pointer"
              @click="deleteTags(index)">
              <i class="fa fa-trash fa-2x"/>
            </span>

            <b-form>
              <label> Name </label>
              <j-input
                v-model="item.name"
                placeholder="Enter tags name"/>
            </b-form>

            <b-row>
              <b-col md="6">
                <j-color-picker
                  v-model="item.background"
                  :color="item.background"
                  label="Background"
                  picker="chrome" />
              </b-col>
              <b-col md="6">
                <j-color-picker
                  v-model="item.font_color"
                  :color="item.font_color"
                  label="Font Color"
                  picker="chrome" />
              </b-col>
            </b-row>
          </div>

          <div
            class="btn-add-column m__b--15"
            @click="addTags">
            + Add options
          </div>
        </div>
        <div v-if="dataSetup.type.id === 'custom_html'">
          <quill-editor
            ref="myQuillEditor"
            v-model="dataSetup.html"
            :options="editorOption"
          />
        </div>
        <div
          v-if="dataSetup.type.id === 'date' ||
          dataSetup.type.id === 'date_time' && !isBulk && !isSearch">
          <b-form
            :class="{'error-input' : $v.dataSetup.isDisableBackDate.$error}"
            class="container-config__item">
            <b-row>
              <b-col :md="10">
                <div class="title-field">
                  <label> Disable Back Date </label>
                  <jTooltipCreateView description="Disable Back Date Information" />
                </div>
              </b-col>
              <b-col :md="2">
                <j-toggle v-model="dataSetup.isDisableBackDate" />
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div
          v-if="(dataSetup.type.id === 'number' ||
            dataSetup.type.id === 'number_decimal' ||
            dataSetup.type.id === 'currency' ||
            dataSetup.type.id === 'single_selection' ||
            dataSetup.type.id === 'text' ||
            dataSetup.type.id === 'date' ||
            dataSetup.type.id === 'time' ||
            dataSetup.type.id === 'date_time' ||
            dataSetup.type.id === 'radio' ||
            dataSetup.type.id === 'checkbox' ||
            dataSetup.type.id === 'toggle' ||
            dataSetup.type.id === 'password' ||
          dataSetup.type.id === 'single_attachment') && !isBulk && !isSearch && !isDataset"
          class="container-config__item">
          <b-form :class="{'error-input' : $v.dataSetup.isValueChange.$error}">
            <b-row>
              <b-col :md="10">
                <div class="title-field">
                  <label> On Value Change </label>
                  <jTooltipCreateView description="On Value Change Information" />
                </div>
              </b-col>
              <b-col :md="2">
                <j-toggle v-model="dataSetup.isValueChange" />
              </b-col>
            </b-row>
          </b-form>
          <b-form
            v-if="useEditorCode"
            :class="{'error-input' : $v.dataSetup.onValueChange.$error}"
          >
            <label> Script </label>
            <j-monaco-editor
              v-if="openEditor"
              ref="scriptEditor"
              :value="dataSetup.onValueChange"
            />
          </b-form>
        </div>
        <div v-if="dataSetup.type.id === 'code_editor'">
          <b-form :class="{'error-input' : $v.dataSetup.language.$error}">
            <label> Language </label>
            <j-single-select
              v-model="$v.dataSetup.language.$model"
              :options="languageOptions"
              placeholder="Select Language"
              label="name"/>
          </b-form>
        </div>
      </b-col>
    </b-row>

    <div class="float-right m__t--10">
      <b-button
        class="btn m__r--5"
        @click="closeModal">
        Close
      </b-button>
      <b-button
        class="btn blue"
        @click="submitForm">
        {{ fieldDetail ? 'Update' : 'Add' }}
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jwtDecode from 'jwt-decode';
import jExternalApiField from '@/views/experience-manager/external-api/jExternalApiField';
import jColumnEditGroup from '@/views/experience-manager/menu/jColumnEditGroup';
import jColumnEditFill from '@/views/experience-manager/menu/jColumnEditFill';
import jColorPicker from '@/components/color-picker/jColorPicker';
import draggable from 'vuedraggable';
import he from 'he';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jTooltipCreateView from '@/components/tooltip/jTooltipCreateView';
import jDateTime from '@/components/inputs/jDateTime';
import jClockpicker from '@/components/inputs/jClockpicker';
import jMixConditionEditor from '@/mixins/jMixConditionEditor';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';

export default {
  components: {
    jExternalApiField,
    jColumnEditGroup,
    jColumnEditFill,
    draggable,
    jColorPicker,
    jMonacoEditor,
    jTooltipCreateView,
    jDateTime,
    jClockpicker,
  },
  mixins: [jMixConditionEditor, jMixAutoScroll],
  props: {
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    variableOptionsWatermark: {
      type: Array,
      default: () => [],
    },
    fieldUiKey: {
      type: Array,
      default: () => [],
    },
    isDetailView: {
      type: Boolean,
      default: () => false,
    },
    isBulk: {
      type: Boolean,
      default: () => false,
    },
    isSearch: {
      type: Boolean,
      default: () => false,
    },
    isDataset: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      dataSetup: {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: false,
        isHidden: false,
        key: null,
        locationType: 1,
        isShowMaps: false,
        options: [''],
        optionsObject: [
          { label: null, value: null },
        ],
        acceptedFileType: [],
        isUseCamera: false,
        isAutoFill: false,
        isWithParam: false,
        isAutoShow: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        filterColumn: null,
        fieldKey: null,
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: null,
        fieldGroup: [],
        isDisableAddMore: false,
        isDisableDeleteRow: false,
        tags: [],
        sourceCamera: null,
        chooseCamera: null,
        html: '',
        isUseWatermark: false,
        field1: null,
        field2: null,
        field3: null,
        isValueChange: false,
        onValueChange: '',
        grid: null,
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        sorting: { key: null, order: null },
        language: null,
        isDisableBackDate: false,
        defaultValue: null,
        isAllowSelectAllData: false,
      },
      openEditor: false,
      editorOption: {},
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      listType: [
        { id: 'text', text: 'Text' },
        { id: 'descriptive', text: 'Long Text' },
        { id: 'number', text: 'Number' },
        { id: 'number_decimal', text: 'Number (Decimal)' },
        { id: 'date', text: 'Date' },
        { id: 'time', text: 'Time' },
        { id: 'date_time', text: 'Date Time' },
        { id: 'location', text: 'Maps' },
        { id: 'single_selection', text: 'Single Selection' },
        { id: 'multiple_selection', text: 'Multiple Selection' },
        { id: 'user_single_selection', text: 'User Single Selection' },
        { id: 'relation_record', text: 'Relation Record' },
        { id: 'multiple_relation_record', text: 'Multiple Relation Record' },
        { id: 'relation_record_external_api', text: 'Relation Record External API' },
        { id: 'multiple_relation_record_external_api', text: 'Multiple Relation Record External API' },
        { id: 'currency', text: 'Currency' },
        { id: 'attachment', text: 'Multiple Attachment' },
        { id: 'multiple_attachment_dynamic', text: 'Multiple Attachment Dynamic' },
        { id: 'single_attachment', text: 'Single Attachment' },
        { id: 'separator', text: 'Separator' },
        { id: 'radio', text: 'Radio' },
        { id: 'checkbox', text: 'Checkbox' },
        { id: 'timer', text: 'Timer' },
        { id: 'single_tags_selection', text: 'Single Tags Selection' },
        { id: 'multiple_tags_selection', text: 'Multiple Tags Selection' },
        { id: 'custom_html', text: 'Custom HTML' },
        { id: 'group', text: 'Group' },
        { id: 'table_group', text: 'Table Group' },
        { id: 'password', text: 'Password' },
        { id: 'code_editor', text: 'Code Editor' },
        { id: 'digital_signature', text: 'Digital Signature' },
        { id: 'color', text: 'Color' },
        { id: 'toggle', text: 'Toggle' },
      ],
      listTypeInBulk: [
        { id: 'text', text: 'Text' },
        { id: 'descriptive', text: 'Long Text' },
        { id: 'number', text: 'Number' },
        { id: 'number_decimal', text: 'Number (Decimal)' },
        { id: 'date', text: 'Date' },
        { id: 'single_selection', text: 'Single Selection' },
        { id: 'multiple_selection', text: 'Multiple Selection' },
        { id: 'relation_record', text: 'Relation Record' },
        { id: 'multiple_relation_record', text: 'Multiple Relation Record' },
        { id: 'relation_record_external_api', text: 'Relation Record External API' },
        { id: 'multiple_relation_record_external_api', text: 'Multiple Relation Record External API' },
        { id: 'single_tags_selection', text: 'Single Tags Selection' },
        { id: 'multiple_tags_selection', text: 'Multiple Tags Selection' },
      ],
      listTypeInSearch: [
        { id: 'text', text: 'Text' },
        { id: 'number', text: 'Number' },
        { id: 'date', text: 'Date' },
        { id: 'single_selection', text: 'Single Selection' },
        { id: 'relation_record', text: 'Relation Record' },
        { id: 'relation_record_external_api', text: 'Relation Record External API' },
        { id: 'single_tags_selection', text: 'Single Tags Selection' },
        { id: 'multiple_tags_selection', text: 'Multiple Tags Selection' },
        { id: 'user_single_selection', text: 'User Single Selection' },
      ],
      listTypeInDataset: [
        { id: 'text', text: 'Text' },
        { id: 'descriptive', text: 'Long Text' },
        { id: 'number', text: 'Number' },
        { id: 'number_decimal', text: 'Number (Decimal)' },
        { id: 'currency', text: 'Currency' },
        { id: 'date', text: 'Date' },
        { id: 'time', text: 'Time' },
        { id: 'date_time', text: 'Date Time' },
        { id: 'toggle', text: 'Toggle' },
      ],
      listLocationType: [
        { id: 1, text: 'Current Location' },
        { id: 2, text: 'Manual Location' },
        { id: 3, text: 'All Type' },
      ],
      list_field_external: [
        { id: 'all', text: 'All' },
        { id: 'id', text: 'ID' },
      ],
      list_accepted_file_type: [
        { id: 'png', text: 'PNG' },
        { id: 'jpg', text: 'JPG' },
        { id: 'jpeg', text: 'JPEG' },
        { id: 'csv', text: 'CSV' },
        { id: 'txt', text: 'TXT' },
        { id: 'xls', text: 'XLS' },
        { id: 'xlsx', text: 'XLSX' },
        { id: 'docx', text: 'DOCX' },
        { id: 'doc', text: 'DOC' },
        { id: 'pdf', text: 'PDF' },
        { id: 'ppt', text: 'PPT' },
        { id: 'pptx', text: 'PPTX' },
        { id: 'mp4', text: 'MP4' },
      ],
      list_choose_camera: [
        { id: 1, text: 'Main & Selfie Camera' },
        { id: 2, text: 'Selfie Camera' },
        { id: 3, text: 'Main Camera' },
      ],
      list_source_camera: [
        { value: true, text: 'Camera & Gallery' },
        { value: false, text: 'Camera Only' },
      ],
      filterOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
      orderOptions: [
        {
          id: 'asc',
          label: 'Ascending',
          text: 'Ascending',
        },
        {
          id: 'desc',
          label: 'Descending',
          text: 'Descending',
        },
      ],
      languageOptions: [
        {
          id: 'html',
          name: 'HTML',
        },
        {
          id: 'javascript',
          name: 'Javascript',
        },
      ],
      listGrid: [
        { id: 12, text: 12 },
        { id: 11, text: 11 },
        { id: 10, text: 10 },
        { id: 9, text: 9 },
        { id: 8, text: 8 },
        { id: 7, text: 7 },
        { id: 6, text: 6 },
        { id: 5, text: 5 },
        { id: 4, text: 4 },
        { id: 3, text: 3 },
        { id: 2, text: 2 },
        { id: 1, text: 1 },
      ],
      list_field: [],
      list_field_key: [],
      list_field_class: [],
      list_field_for_issearch: [],
      tableGroupOptions: [],
      tableOptions: [],
      popoverExternalApiShow: false,
      finishSetDataTableGroup: false,

      // for group
      isOpen: false,
      selectedField: null,
      selectedIndexField: null,
      variableOptionsGroup: [],

      problemMessage: '',
      isError: false,
      darkMode: false,
      tabSelected: 'value',

      exampleOptionCurrency: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'Rp',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '99999999999999',
      },
    };
  },
  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),

    typeFieldByType() {
      if (this.isBulk) {
        return this.listTypeInBulk;
      } else if (this.isSearch) {
        return this.listTypeInSearch;
      } else if (this.isDataset) {
        return this.listTypeInDataset;
      }
      return this.listType;
    },

    isHaveConfig() {
      if (this.dataSetup.type) {
        if (this.isBulk || this.isSearch) {
          const typeNotConfig = ['text', 'date', 'time', 'date_time', 'number', 'number_decimal', 'currency', 'descriptive', 'user_single_selection', 'separator', 'timer', 'password', 'color'];
          return !typeNotConfig.includes(this.dataSetup.type.id);
        }
        if (this.isDataset) {
          return false;
        }
        const typeNotConfig = ['descriptive', 'user_single_selection', 'separator', 'timer', 'digital_signature', 'color'];
        return !typeNotConfig.includes(this.dataSetup.type.id);
      }
      return false;
    },

    isNoGrid() {
      if (this.dataSetup.type) {
        const typeNotGrid = ['location', 'attachment', 'multiple_attachment_dynamic', 'single_attachment', 'separator', 'custom_html', 'group', 'table_group', 'code_editor', 'digital_signature'];
        return typeNotGrid.includes(this.dataSetup.type.id) || ((this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') && this.dataSetup.optionsObject.length > 2) || this.isBulk;
      }
      return false;
    },

    // eslint-disable-next-line consistent-return
    variableOptionsFiltered() {
      if (this.dataSetup.type && this.dataSetup.type.id === 'toggle') {
        return this.variableOptions.filter(f => f.type === 'boolean');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'user_single_selection') {
        return this.variableOptions.filter(f => f.type === 'person');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'timer') {
        return this.variableOptions.filter(f => f.type === 'timer');
      } else if (this.dataSetup.type &&
                this.dataSetup.type.id === 'single_tags_selection') {
        return this.variableOptions.filter(f => f.type === 'tags');
      } else if (this.dataSetup.type &&
                this.dataSetup.type.id === 'multiple_tags_selection') {
        return this.variableOptions.filter(f => f.type === '[]tags');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'multiple_attachment_dynamic' ||
                this.dataSetup.type.id === 'attachment')) {
        return this.variableOptions.filter(f => f.type === '[]attachment');
      } else if (this.dataSetup.type && !this.isDataset &&
                (this.dataSetup.type.id === 'radio' ||
                this.dataSetup.type.id === 'text' ||
                this.dataSetup.type.id === 'descriptive' ||
                this.dataSetup.type.id === 'single_selection' ||
                this.dataSetup.type.id === 'single_attachment' ||
                this.dataSetup.type.id === 'password' ||
                this.dataSetup.type.id === 'digital_signature' ||
                this.dataSetup.type.id === 'color' ||
                this.dataSetup.type.id === 'code_editor')) {
        return this.variableOptions.filter(f => f.type === 'text');
      } else if (this.dataSetup.type && this.isDataset &&
                (this.dataSetup.type.id === 'text' ||
                this.dataSetup.type.id === 'descriptive')) {
        return this.variableOptions.filter(f => f.type === 'text' || f.type === 'varchar');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'checkbox' ||
                this.dataSetup.type.id === 'multiple_selection')) {
        return this.variableOptions.filter(f => f.type === '[]text');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'number' ||
                this.dataSetup.type.id === 'number_decimal' ||
                this.dataSetup.type.id === 'currency')) {
        return this.variableOptions.filter(f => f.type === 'number' || f.type === 'integer' || f.type === 'big_integer' || f.type === 'small_integer');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'date' ||
                this.dataSetup.type.id === 'date_time' ||
                this.dataSetup.type.id === 'time')) {
        return this.variableOptions.filter(f => f.type === 'timestamp');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'location') {
        return this.variableOptions.filter(f => f.type === 'maps');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'relation_record' ||
                this.dataSetup.type.id === 'relation_record_external_api')) {
        return this.variableOptions.filter(f => f.type === 'object');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'multiple_relation_record' ||
                this.dataSetup.type.id === 'multiple_relation_record_external_api')) {
        return this.variableOptions.filter(f => f.type === '[]object');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'group' ||
                this.dataSetup.type.id === 'table_group')) {
        return this.variableOptions.filter(f => f.type === `[]${f.id}`);
      }
    },
  },
  watch: {
    // eslint-disable-next-line
    'dataSetup.sourceData.tableGroup': function (val) {
      if (this.finishSetDataTableGroup) this.dataSetup.sourceData.form = null;
      setTimeout(() => { this.$v.dataSetup.$reset(); }, 10);

      if (val) {
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (!res.error) {
            this.tableOptions = res.data || [];
          }
        });
      }
    },

    // eslint-disable-next-line
    'dataSetup.sourceData.form': function(data) {
      const listColumns = Object.keys(data.columns);
      const listColumnsVal = Object.values(data.columns);
      this.list_field = listColumnsVal.map((e) => {
        e.id = e.name;
        e.text = e.name;
        e.label = e.name;
        return e;
      });

      this.list_field_for_issearch = listColumnsVal.filter(f => f.type === 'object').map((e) => {
        e.id = e.name;
        e.text = e.name;
        e.label = e.name;
        return e;
      });

      this.list_field_class = [];
      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          if (listColumnsVal[index].type !== '[]attachment') {
            if (listColumnsVal[index].type === 'person') {
              this.list_field_class.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
              });
              this.list_field_class.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
              });
              this.list_field_class.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
              });
            } else if (listColumnsVal[index].type === 'object') {
              this.list_field_class.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
              });
              this.list_field_class.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
              });
            } else if (listColumnsVal[index].type === 'timer') {
              this.list_field_class.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
              });
              this.list_field_class.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
              });
            } else if (listColumnsVal[index].type === 'tags') {
              this.list_field_class.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
              });
              this.list_field_class.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
              });
              this.list_field_class.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
              });
            } else if (listColumnsVal[index].type === 'maps') {
              this.list_field_class.push({
                id: `${column}.latitude`,
                label: `${column}.latitude`,
                text: `${column}.latitude`,
              });
              this.list_field_class.push({
                id: `${column}.longitude`,
                label: `${column}.longitude`,
                text: `${column}.longitude`,
              });
              this.list_field_class.push({
                id: `${column}.address`,
                label: `${column}.address`,
                text: `${column}.address`,
              });
            }
            // else {
            this.list_field_class.push({
              id: column,
              label: column,
              text: column,
            });
            // }
          }
        });
      }
    },

    // eslint-disable-next-line
    'dataSetup.key': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataSetup.key = val ?
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_') : null;
      }, 1);
    },

    // eslint-disable-next-line
    'dataSetup.variable': function (val){
      const classGroup = this.form_data_detail.length > 0 ? this.form_data_detail[0].class[val.id] : null;
      if (classGroup) {
        const dataColumns = Object.values(classGroup);
        this.variableOptionsGroup = dataColumns.map((e) => {
          e.id = e.name;
          e.text = e.name;
          e.label = e.name;
          e.type = e.type;
          return e;
        });
      }
    },

    // eslint-disable-next-line
    'dataSetup.isUseCamera': function (val){
      this.dataSetup.sourceCamera = null;
      this.dataSetup.chooseCamera = null;
    },

    // eslint-disable-next-line
    'dataSetup.isUseWatermark': function (val){
      this.dataSetup.field1 = null;
      this.dataSetup.field2 = null;
      this.dataSetup.field3 = null;
    },

    // eslint-disable-next-line
    'dataSetup.type': function (val){
      if (val) {
        const typeNotGrid = ['location', 'attachment', 'multiple_attachment_dynamic', 'single_attachment', 'separator', 'custom_html', 'group', 'table_group', 'code_editor', 'digital_signature'];
        if (typeNotGrid.includes(val.id) || this.isBulk) {
          this.dataSetup.grid = 12;
        } else {
          this.dataSetup.grid = null;
        }
      }
      this.dataSetup.defaultValue = null;
    },

    // eslint-disable-next-line
    'dataSetup.optionsObject': function (val){
      if ((this.dataSetup.type && (this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') && val.length > 2) || this.isBulk) {
        this.dataSetup.grid = 12;
      } else {
        this.dataSetup.grid = null;
      }
    },
  },
  created() {
    this.getListGroupTable();
    this.openEditor = false;
    if (this.fieldDetail) {
      this.dataSetup = {
        name: this.fieldDetail.name,
        placeholder: this.fieldDetail.placeholder,
        type: { id: this.fieldDetail.type },
        variable: this.fieldDetail.field_data_key ? { id: this.fieldDetail.field_data_key } : null,
        isMandatory: this.fieldDetail.is_mandatory,
        isDisable: this.fieldDetail.is_disable,
        isHidden: this.fieldDetail.is_hidden,
        key: this.fieldDetail.field_ui_key,
        locationType: this.fieldDetail.type === 'location' ? this.fieldDetail.config.map_type : 1,
        isShowMaps: this.fieldDetail.type === 'location' ? this.fieldDetail.config.is_show_maps : false,
        options: this.fieldDetail.type === 'single_selection' ||
            this.fieldDetail.type === 'multiple_selection' ||
            this.fieldDetail.type === 'photo' ||
            this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'radio' ||
            this.fieldDetail.type === 'checkbox' ? (this.fieldDetail.config.list_options ? this.fieldDetail.config.list_options : ['']) : [''],
        optionsObject: this.fieldDetail.type === 'radio' || this.fieldDetail.type === 'checkbox' ? (this.fieldDetail.config.list_options_object ? this.fieldDetail.config.list_options_object : [{ label: null, value: null }]) : [{ label: null, value: null }],
        acceptedFileType: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.accepted_file_type : [],
        isUseCamera: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.is_use_camera : false,
        isAutoFill: this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'relation_record_external_api' ? this.fieldDetail.config.is_auto_fill : false,
        isWithParam: this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.is_with_param : false,
        isAutoShow: this.fieldDetail.type === 'relation_record' ||
                    this.fieldDetail.type === 'multiple_relation_record' ||
                    this.fieldDetail.type === 'relation_record_external_api' ||
                    this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.is_auto_show : false,
        sourceData: {
          tableGroup: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.table_group : null,
          form: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.form : null,
          showData: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.show_data_option : null,
          searchData: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.search_data_option : null,
          setValue: this.fieldDetail.type === 'relation_record' ||
            this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.set_value_selected : null,
        },
        filterColumn: this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.filter_column : null,
        fieldKey: this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.field_key : null,
        sourceExternal: this.fieldDetail.type === 'relation_record_external_api' ||
            this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.data_source_external : null,
        sourceExternalVariable: this.fieldDetail.type === 'relation_record_external_api' ||
            this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.data_source_external_variable : '',
        sourceExternalSetValue: this.fieldDetail.type === 'relation_record_external_api' ||
            this.fieldDetail.type === 'multiple_relation_record_external_api' ? this.fieldDetail.config.data_source_external_set_value : null,
        fieldGroup: this.fieldDetail.type === 'group' || this.fieldDetail.type === 'table_group' ? this.fieldDetail.config.data_field_group :
          (this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'relation_record_external_api' ? this.fieldDetail.config.data_field_auto : []),
        isDisableAddMore: this.fieldDetail.type === 'group' || this.fieldDetail.type === 'table_group' ? this.fieldDetail.config.is_disable_add_more : false,
        isDisableDeleteRow: this.fieldDetail.type === 'group' || this.fieldDetail.type === 'table_group' ? this.fieldDetail.config.is_disable_delete_row : false,
        tags: this.fieldDetail.type === 'single_tags_selection' || this.fieldDetail.type === 'multiple_tags_selection' ? this.fieldDetail.config.list_tags : [],
        sourceCamera: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.is_can_access_gallery : null,
        chooseCamera: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.camera_type : null,
        html: this.fieldDetail.type === 'custom_html' ? he.decode(this.fieldDetail.config.html) : '',
        isUseWatermark: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.is_use_watermark : false,
        field1: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.field_1 : null,
        field2: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.field_2 : null,
        field3: this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.field_3 : null,
        isValueChange: (this.fieldDetail.type === 'number' ||
                        this.fieldDetail.type === 'number_decimal' ||
                        this.fieldDetail.type === 'currency' ||
                        this.fieldDetail.type === 'single_selection' ||
                        this.fieldDetail.type === 'text' ||
                        this.fieldDetail.type === 'date' ||
                        this.fieldDetail.type === 'time' ||
                        this.fieldDetail.type === 'date_time' ||
                        this.fieldDetail.type === 'relation_record' ||
                        this.fieldDetail.type === 'radio' ||
                        this.fieldDetail.type === 'checkbox' ||
                        this.fieldDetail.type === 'toggle' ||
                        this.fieldDetail.type === 'password' ||
                        this.fieldDetail.type === 'single_attachment' ||
                        this.fieldDetail.type === 'relation_record_external_api') && this.fieldDetail.config ? this.fieldDetail.config.is_value_change : false,
        onValueChange: (this.fieldDetail.type === 'number' ||
                        this.fieldDetail.type === 'number_decimal' ||
                        this.fieldDetail.type === 'currency' ||
                        this.fieldDetail.type === 'single_selection' ||
                        this.fieldDetail.type === 'text' ||
                        this.fieldDetail.type === 'date' ||
                        this.fieldDetail.type === 'time' ||
                        this.fieldDetail.type === 'date_time' ||
                        this.fieldDetail.type === 'relation_record' ||
                        this.fieldDetail.type === 'radio' ||
                        this.fieldDetail.type === 'checkbox' ||
                        this.fieldDetail.type === 'toggle' ||
                        this.fieldDetail.type === 'password' ||
                        this.fieldDetail.type === 'single_attachment' ||
                        this.fieldDetail.type === 'relation_record_external_api') && this.fieldDetail.config ? this.fieldDetail.config.on_value_change : '',
        grid: this.fieldDetail.grid_size ? this.fieldDetail.grid_size : null,
        filter: [{ key: null, value: null }],
        filterOperator: this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.filter_operator : null,
        sorting: { key: null, order: null },
        language: this.fieldDetail.type === 'code_editor' ? this.fieldDetail.config.language : null,
        isDisableBackDate: (this.fieldDetail.type === 'date' || this.fieldDetail.type === 'date_time') && this.fieldDetail.config ? this.fieldDetail.config.is_disable_back_date : false,
        defaultValue: null,
        isAllowSelectAllData: (this.fieldDetail.type === 'multiple_relation_record' || this.fieldDetail.type === 'multiple_relation_record_external_api') && this.fieldDetail.config ? this.fieldDetail.config.allow_select_all_data : false,
      };
      setTimeout(() => {
        this.dataSetup.sourceCamera = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.is_can_access_gallery : null;
        this.dataSetup.chooseCamera = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.camera_type : null;
        this.dataSetup.field1 = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.field_1 : null;
        this.dataSetup.field2 = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.field_2 : null;
        this.dataSetup.field3 = this.fieldDetail.type === 'attachment' ||
            this.fieldDetail.type === 'multiple_attachment_dynamic' ||
            this.fieldDetail.type === 'single_attachment' ? this.fieldDetail.config.field_3 : null;
        this.dataSetup.grid = this.fieldDetail.grid_size ? this.fieldDetail.grid_size : null;
        this.dataSetup.defaultValue = this.setDefaultValue(this.fieldDetail.config ? this.fieldDetail.config.default_value : null, this.fieldDetail.type);
      }, 500);
      if (this.fieldDetail.config && this.fieldDetail.config.sort) {
        const keySort = Object.keys(this.fieldDetail.config.sort[0]);
        const valueSort = Object.values(this.fieldDetail.config.sort[0]);

        this.dataSetup.sorting = {
          key: { id: keySort[0] },
          order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
        };
      }
      if (this.fieldDetail.config && this.fieldDetail.config.filter) {
        const keyFilter = Object.keys(this.fieldDetail.config.filter);
        const valueFilter = Object.values(this.fieldDetail.config.filter);
        if (keyFilter.length > 0) {
          this.dataSetup.filter = [];
          keyFilter.forEach((e, index) => {
            this.dataSetup.filter.push({
              key: { id: e },
              value: valueFilter[index],
            });
          });
        }
      }
    } else {
      this.dataSetup = {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: this.isDataset,
        isHidden: false,
        key: null,
        locationType: 1,
        isShowMaps: false,
        options: [''],
        optionsObject: [
          { label: null, value: null },
        ],
        acceptedFileType: [],
        isUseCamera: false,
        isAutoFill: false,
        isWithParam: false,
        isAutoShow: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        filterColumn: null,
        fieldKey: null,
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: null,
        fieldGroup: [],
        isDisableAddMore: false,
        isDisableDeleteRow: false,
        tags: [
          {
            name: '',
            background: '#000000',
            font_color: '#000000',
          },
        ],
        sourceCamera: null,
        chooseCamera: null,
        html: '',
        isUseWatermark: false,
        field1: null,
        field2: null,
        field3: null,
        isValueChange: false,
        onValueChange: '',
        grid: null,
        filter: [{ key: null, value: null }],
        filterOperator: null,
        sorting: { key: null, order: null },
        language: null,
        isDisableBackDate: false,
        defaultValue: null,
        isAllowSelectAllData: false,
      };

      this.$v.dataSetup.$reset();
    }

    if (this.isSearch) {
      this.list_field_key = this.fieldUiKey.filter(f => f.type === 'relation_record').map(e => ({
        id: e.field_data_key,
        text: e.field_data_key,
        label: e.field_data_key,
        name: e.field_data_key,
      }));
    } else {
      this.list_field_key = this.fieldUiKey.filter(f => f.type === 'relation_record').map((e) => {
        e.id = e.field_ui_key;
        e.text = e.name;
        e.label = e.name;
        return e;
      });
    }

    setTimeout(() => {
      if (this.isBulk) { this.dataSetup.grid = 12; }
      this.openEditor = true;
    }, 500);
  },
  methods: {
    ...mapActions('jStoreFormUi', ['actionSetForm']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const { name, placeholder, type, variable, isMandatory, isDisable, isHidden, key, grid } = this.dataSetup;
        let dataConfig = null;
        if (this.dataSetup.type.id === 'location') {
          dataConfig = { map_type: this.dataSetup.locationType, is_show_maps: this.dataSetup.isShowMaps };
        }
        if (this.dataSetup.type.id === 'single_selection' ||
            this.dataSetup.type.id === 'multiple_selection' ||
            this.dataSetup.type.id === 'photo') {
          dataConfig = { list_options: this.dataSetup.options };
        }
        if (this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') {
          dataConfig = { list_options_object: this.dataSetup.optionsObject.length > 0 ? (this.dataSetup.optionsObject[0].value === null ? null : this.dataSetup.optionsObject) : null };
          if (this.dataSetup.options.length > 0 && this.dataSetup.options[0] !== '') {
            dataConfig.list_options = this.dataSetup.options;
          }
        }
        if (this.dataSetup.type.id === 'attachment') {
          dataConfig = {
            list_options: this.dataSetup.options,
            accepted_file_type: this.dataSetup.acceptedFileType,
            is_use_camera: this.dataSetup.isUseCamera,
            is_can_access_gallery: this.dataSetup.sourceCamera,
            camera_type: this.dataSetup.chooseCamera,
            is_use_watermark: this.dataSetup.isUseWatermark,
            field_1: this.dataSetup.field1 ? this.dataSetup.field1 : null,
            field_2: this.dataSetup.field2 ? this.dataSetup.field2 : null,
            field_3: this.dataSetup.field3 ? this.dataSetup.field3 : null,
          };
        }
        if (this.dataSetup.type.id === 'single_attachment' || this.dataSetup.type.id === 'multiple_attachment_dynamic') {
          dataConfig = {
            list_options: [],
            accepted_file_type: this.dataSetup.acceptedFileType,
            is_use_camera: this.dataSetup.isUseCamera,
            is_can_access_gallery: this.dataSetup.sourceCamera,
            camera_type: this.dataSetup.chooseCamera,
            is_use_watermark: this.dataSetup.isUseWatermark,
            field_1: this.dataSetup.field1 ? this.dataSetup.field1 : null,
            field_2: this.dataSetup.field2 ? this.dataSetup.field2 : null,
            field_3: this.dataSetup.field3 ? this.dataSetup.field3 : null,
          };
        }
        if (this.dataSetup.type.id === 'relation_record' ||
            this.dataSetup.type.id === 'multiple_relation_record') {
          dataConfig = {
            data_source: {
              table_group: this.dataSetup.sourceData.tableGroup,
              form: this.dataSetup.sourceData.form,
              show_data_option: this.dataSetup.sourceData.showData,
              search_data_option: this.dataSetup.sourceData.searchData,
              set_value_selected: this.dataSetup.sourceData.setValue,
            },
            is_auto_show: this.dataSetup.isAutoShow,
            is_with_param: this.dataSetup.isWithParam,
            filter_column: this.dataSetup.filterColumn,
            field_key: this.dataSetup.fieldKey,
            filter: {},
            filter_operator: this.dataSetup.filterOperator ? this.dataSetup.filterOperator : 'and',
            sort: [],
          };
          if (this.dataSetup.sorting.key && this.dataSetup.sorting.order) {
            dataConfig.sort.push({
              [this.dataSetup.sorting.key.id]: this.dataSetup.sorting.order.id === 'asc' ? 1 : -1,
            });
          }
          if (this.dataSetup.filter.length > 0) {
            this.dataSetup.filter.forEach((e) => {
              if (e.key) {
                dataConfig.filter[e.key.id] = e.value;
              }
            });
          }
          if (this.dataSetup.type.id === 'relation_record' && !this.isBulk && !this.isSearch) {
            dataConfig.data_field_auto = this.dataSetup.fieldGroup;
            dataConfig.is_auto_fill = this.dataSetup.isAutoFill;
            dataConfig.is_value_change = this.dataSetup.isValueChange;
            dataConfig.on_value_change = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange;
          }
        }
        if (this.dataSetup.type.id === 'relation_record_external_api' ||
            this.dataSetup.type.id === 'multiple_relation_record_external_api') {
          dataConfig = {
            data_source_external: this.dataSetup.sourceExternal,
            data_source_external_variable: this.dataSetup.sourceExternalVariable,
            data_source_external_set_value: this.dataSetup.sourceExternalSetValue,
            is_auto_show: this.dataSetup.isAutoShow,
          };
          if (this.dataSetup.type.id === 'relation_record_external_api') {
            dataConfig.data_field_auto = this.dataSetup.fieldGroup;
            dataConfig.is_auto_fill = this.dataSetup.isAutoFill;
            dataConfig.is_value_change = this.dataSetup.isValueChange;
            dataConfig.on_value_change = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange;
          }
        }
        if (this.dataSetup.type.id === 'group' || this.dataSetup.type.id === 'table_group') {
          dataConfig = {
            data_field_group: this.dataSetup.fieldGroup,
            is_disable_add_more: this.dataSetup.isDisableAddMore,
            is_disable_delete_row: this.dataSetup.isDisableDeleteRow,
          };
        }
        if (this.dataSetup.type.id === 'single_tags_selection' || this.dataSetup.type.id === 'multiple_tags_selection') {
          dataConfig = { list_tags: this.dataSetup.tags };
        }
        if (this.dataSetup.type.id === 'custom_html') {
          dataConfig = { html: this.encodeHtmlEntities(this.dataSetup.html) };
        }
        if ((this.dataSetup.type.id === 'number' ||
            this.dataSetup.type.id === 'number_decimal' ||
            this.dataSetup.type.id === 'currency' ||
            this.dataSetup.type.id === 'text' ||
            this.dataSetup.type.id === 'date' ||
            this.dataSetup.type.id === 'time' ||
            this.dataSetup.type.id === 'date_time' ||
            this.dataSetup.type.id === 'toggle' ||
            this.dataSetup.type.id === 'password') && !this.isBulk && !this.isSearch && !this.isDataset) {
          dataConfig = {
            is_value_change: this.dataSetup.isValueChange,
            on_value_change: this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange,
            default_value: this.getDefaultValue(this.dataSetup.defaultValue, this.dataSetup.type.id),
          };
        }
        if ((this.dataSetup.type.id === 'single_selection' ||
            this.dataSetup.type.id === 'radio' ||
            this.dataSetup.type.id === 'checkbox' ||
            this.dataSetup.type.id === 'single_attachment') && !this.isBulk && !this.isSearch) {
          dataConfig.is_value_change = this.dataSetup.isValueChange;
          dataConfig.on_value_change = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange;
        }
        if (this.dataSetup.type.id === 'code_editor') {
          dataConfig = { language: this.dataSetup.language };
        }
        if ((this.dataSetup.type.id === 'date' || this.dataSetup.type.id === 'date_time') && !this.isBulk && !this.isSearch && !this.isDataset) {
          dataConfig.is_disable_back_date = this.dataSetup.isDisableBackDate;
        }
        if (this.dataSetup.type.id === 'descriptive' && !this.isDataset) {
          dataConfig = { default_value: this.dataSetup.defaultValue };
        }
        if (this.dataSetup.type.id === 'single_selection') {
          dataConfig.default_value = this.dataSetup.defaultValue;
        }
        if (this.dataSetup.type.id === 'multiple_relation_record' || this.dataSetup.type.id === 'multiple_relation_record_external_api') {
          dataConfig.allow_select_all_data = this.dataSetup.isAllowSelectAllData;
        }
        const params = {
          name,
          placeholder,
          type: type.id,
          field_data_key: variable ? variable.id : '',
          is_mandatory: isMandatory,
          is_hidden: isHidden,
          is_disable: isDisable,
          field_ui_key: key,
          grid_size: grid,
          config: dataConfig,
        };

        if (this.fieldDetail) {
          this.$emit('submit-mode', 'edit', params);
        } else {
          this.$emit('submit-mode', 'add', params);
        }
        this.$emit('close-modal');
      } else {
        this.scrollToErrorField('error-input');
      }
    },
    setDefaultValue(value, type) {
      if (value) {
        // if (type === 'time') {
        //   return this.convertTime(value);
        // } else if (type === 'date' || type === 'date_time') {
        //   return this.converToLocalTime(value);
        // }
        return value;
      }
      return null;
    },
    getDefaultValue(value, type) {
      if (value) {
        if (type === 'number' || type === 'number_decimal' || type === 'currency') {
          return Number(value);
        }
        // else if (type === 'time') {
        //   return this.countSecond(value);
        // } else if (type === 'date') {
        //   const convertDate = this.$moment(value).format('YYYY-MM-DD');
        //   return new Date(Date.parse(convertDate)).getTime();
        // } else if (type === 'date_time') {
        //   const convertDate = this.$moment(value).format('YYYY-MM-DD HH:mm');
        //   return new Date(Date.parse(convertDate)).getTime();
        // }
        return value;
      }
      return null;
    },
    converToLocalTime(data) {
      if (data) {
        const dt = new Date(data);
        const localDate = dt;

        const gmt = localDate;
        const min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
        const localNow = new Date().getTimezoneOffset(); // get the timezone
        const localTime = min + localNow; // get the local time

        const fullDate = new Date(localTime * 1000 * 60);
        const year = fullDate.getFullYear();
        const month = `0${fullDate.getMonth() + 1}`;
        const date = `0${fullDate.getDate()}`;
        const hours = `0${fullDate.getHours()}`;
        const minutes = `0${fullDate.getMinutes()}`;
        const utc = `${year}-${month.substr(-2)}-${date.substr(-2)}T${hours.substr(-2)}:${minutes.substr(-2)}:00.000Z`;

        return utc;
      }
      return null;
    },
    convertDateTime(data) {
      if (data) {
        // const date = new Date(data.toString().length === 13 || data.toString().length === 12 ? data : data * 1000);
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
    convertTime(data) {
      if (data) {
        // const date = new Date(data.toString().length === 13 || data.toString().length === 12 ? data : data * 1000);
        const date = new Date(data);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
      }
      return null;
    },
    countSecond(str) {
      const date = new Date();
      return new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${str}:00`)).getTime();
    },
    closeModal() {
      this.dataSetup = {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: false,
        isHidden: false,
        key: null,
        locationType: 1,
        isShowMaps: false,
        options: [''],
        optionsObject: [
          { label: null, value: null },
        ],
        acceptedFileType: [],
        isUseCamera: false,
        isAutoFill: false,
        isWithParam: false,
        isAutoShow: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        filterColumn: null,
        fieldKey: null,
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: null,
        fieldGroup: [],
        tags: [
          {
            name: '',
            background: '#000000',
            font_color: '#000000',
          },
        ],
        sourceCamera: null,
        chooseCamera: null,
        html: '',
        isUseWatermark: false,
        field1: null,
        field2: null,
        field3: null,
        isValueChange: false,
        onValueChange: '',
        grid: null,
        filter: [{ key: null, value: null }],
        filterOperator: null,
        sorting: { key: null, order: null },
        language: null,
        isDisableBackDate: false,
        defaultValue: null,
      };

      this.$v.dataSetup.$reset();
      this.$emit('close-modal');
    },
    addoptions() {
      this.dataSetup.options.push('');
    },
    deleteOptions(index) {
      this.dataSetup.options.splice(index, 1);
    },
    addoptionsObject() {
      this.dataSetup.optionsObject.push({ label: null, value: null });
    },
    deleteOptionsObject(index) {
      this.dataSetup.optionsObject.splice(index, 1);
    },
    addTags() {
      this.dataSetup.tags.push({
        name: '',
        background: '#000000',
        font_color: '#000000',
      });
    },
    deleteTags(index) {
      this.dataSetup.tags.splice(index, 1);
    },
    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 50,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreAutomation/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    closeModalExternalUrl() {
      this.popoverExternalApiShow = false;
    },
    submitExternalUrl(data) {
      this.dataSetup.sourceExternal = data;
      this.popoverExternalApiShow = false;
    },
    deleteField(index) {
      this.dataSetup.fieldGroup.splice(index, 1);
    },
    openModalEditField(data, index) {
      this.selectedField = data;
      this.selectedIndexField = index;
      this.isOpen = true;
      this.$refs.popoverFieldGroup.$emit('open');
    },
    closeModalEditField() {
      if (!this.isError) {
        this.isOpen = false;
        this.$refs.popoverFieldGroup.$emit('close');
      }
    },
    addFilter() {
      this.dataSetup.filter.push({
        key: null,
        value: null,
      });
    },
    deleteFilter(index) {
      this.dataSetup.filter.splice(index, 1);
    },
    submitField(mode, params) {
      const findKeySame = this.dataSetup.fieldGroup.find(e => e.field_ui_key === params.field_ui_key);
      if (mode === 'add') {
        if (!findKeySame) {
          this.isError = false;
          this.dataSetup.fieldGroup.push(params);
        } else {
          this.isError = true;
          this.toggleProblem('Key cannot be the same!');
        }
      } else {
        // eslint-disable-next-line
        if (this.selectedField.field_ui_key === params.field_ui_key) {
          this.isError = false;
          this.dataSetup.fieldGroup[this.selectedIndexField] = params;
        } else {
          // eslint-disable-next-line
          if (!findKeySame) {
            this.isError = false;
            this.dataSetup.fieldGroup[this.selectedIndexField] = params;
          } else {
            this.isError = true;
            this.toggleProblem('Key cannot be the same!');
          }
        }
      }
    },
    encodeHtmlEntities(str) {
      return he.encode(str);
    },
    setValueDateAndAtime(val) {
      this.dataSetup.defaultValue = val;
    },
    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];

          if (this.fieldDetail && this.fieldDetail.config && this.fieldDetail.config.data_source && !this.fieldDetail.config.data_source.table_group) {
            const formDataTableGroup = this.fieldDetail.config &&
            this.fieldDetail.config.data_source &&
            this.fieldDetail.config.data_source.form &&
            this.fieldDetail.config.data_source.form.tablegroup_id;
            const findTableGroup = res.data.find(f => f.id === formDataTableGroup);
            if (findTableGroup) {
              this.dataSetup.sourceData.tableGroup = findTableGroup;
            }
            const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
            if (findTableGroupLegacy && !formDataTableGroup) {
              this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
            }

            setTimeout(() => {
              this.dataSetup.sourceData.form = this.fieldDetail.type === 'relation_record' ||
                this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.form : null;
            }, 500);
          }

          setTimeout(() => { this.finishSetDataTableGroup = true; }, 1000);
        }
      });
    },
  },
  validations() {
    return {
      dataSetup: {
        name: {
          required,
        },
        placeholder: {
          // required,
        },
        type: {
          required,
        },
        variable: {
          // required,
          required: requiredIf(() => this.dataSetup.type && (this.dataSetup.type.id !== 'separator' && this.dataSetup.type.id !== 'custom_html')),
        },
        isMandatory: {
          // required,
        },
        isDisable: {
          // required,
        },
        isHidden: { },
        key: {
          required: requiredIf(() => !this.isSearch),
        },
        locationType: {
          required: requiredIf(() => (this.dataSetup.type && this.dataSetup.type.id) === 'location'),
        },
        isShowMaps: { },
        options: {
          $each: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'single_selection' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_selection' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'attachment';
            }),
          },
        },
        optionsObject: {
          $each: {
            // required,
          },
        },
        acceptedFileType: {
          // eslint-disable-next-line arrow-body-style
          required: requiredIf(() => {
            return (this.dataSetup.type && this.dataSetup.type.id) === 'attachment' ||
                    (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_attachment_dynamic' ||
                    (this.dataSetup.type && this.dataSetup.type.id) === 'single_attachment';
          }),
        },
        isUseCamera: {},
        isAutoFill: {},
        isWithParam: {},
        isAutoShow: {},
        sourceData: {
          tableGroup: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          form: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          showData: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          searchData: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          setValue: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
        },
        filterColumn: {},
        fieldKey: {},
        isDisableAddMore: {},
        isDisableDeleteRow: {},
        sourceExternalVariable: {},
        sourceExternalSetValue: {},
        sourceCamera: {},
        chooseCamera: {},
        html: {},
        isUseWatermark: {},
        field1: {},
        field2: {},
        field3: {},
        isValueChange: {},
        onValueChange: {},
        grid: {},
        filter: {},
        filterOperator: {},
        sorting: {
          key: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          order: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
        },
        language: {},
        isDisableBackDate: {},
        defaultValue: {},
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .btn-add-column {
    color: #808285;
    cursor: pointer;
    font-family: 'Poppins-Medium';
    font-size: 12px;
  }

  .external-ui {
    height: 50px;
    margin: 7px 0 22px;
    padding: 12px 138px 11px 14px;
    border-radius: 8px;
    background-color: #f3f3f3;
    font-family: Poppins-Medium;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #626262;
  }

  .font-blue {
    color: #1a85e4 !important;
  }

  .list-column-ui {
    background-color: #f9f9f9;
    margin: 8px 0;
    padding: 4px 8px;
  }

  .container-group__item {
    border-top: 1px solid #ccc;
    padding: 10px 30px;
    position: relative;
  }

  .item__counter-group {
    position: absolute;
    top: -14px;
    left: 0;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 13px;
    width: 26px;
    height: 26px;
    padding-top: 3px;
    font-size: 12px;
    text-align: center;
  }

  .item__remove {
    position: absolute;
    top: -14px;
    right: 0;
    background-color: #fff;
  }

  .filter-container {
    margin: 8px 0 8px 3px;
    border-radius: 8px;
    background-color: #f9f9f9;
  }

  .w--100 {
    width: 100% !important;
  }

  .tab-filter {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    cursor: pointer;
  }

  .tab-filter-active {
    border-bottom: 4px solid #4a90e2;
  }

  .title-field {
    display: flex;
    align-items: center;

    label {
      margin-right: 5px;
      margin-bottom: 0;
    }
  }

  .container-group-table-group {
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    border-radius: 13px;
    padding: 19px;
    margin-bottom: 17px;
  }

  .container-config__item {
    border: 1px solid #e2e2e2;
    box-sizing: border-box;
    border-radius: 13px;
    margin-bottom: 17px;
    padding: 17px 36px 6px 23px;

      label {
        font-size: 14px;
      }
  }

  .container-monaco-editor {
    margin-top: 9px;
    margin-bottom: 33px;
  }

</style>



// WEBPACK FOOTER //
// src/views/experience-manager/menu/jColumnEdit.vue